module.exports = __webpack_public_path__ + "assets/images/psychologic_g.d97bbf29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/psychologic_g.png
// module id = 761
// module chunks = 1